<template>
  <div
    class="syue-stepper height-default"
    :class="{
        'disabled': disabled,
        'syue-stepper-mini height-mini': size === 'mini',
        'syue-stepper-small height-small': size === 'small',
        'syue-stepper-medium height-medium': size === 'medium'
      }"
  >
    <div
      v-if="controls"
      class="syue-stepper-button syue-stepper-button-reduce"
      @click="$_reduce"
    ><i class="el-icon-minus"></i>
    </div>
    <div class="syue-stepper-number">
      <!-- <input type="text"
        v-if="blurCheck"
        :size="contentLength"
        v-model="currentNum"
        :readOnly="readOnly"
        :disabled="disabled"
        :placeholder="placeholder"
        @focus="focus"
        @blur="$_formatInput"> -->
      <input type="text"
             :size="contentLength"
             v-model="currentNum"
             :readOnly="readOnly"
             :placeholder="placeholder"
             :disabled="disabled"
             @focus="$_focus"
             @input="$_input"
             @blur="$_blur">
    </div>
    <div
      v-if="controls"
      class="syue-stepper-button syue-stepper-button-add"
      @click="$_add"
    ><i class="el-icon-plus"></i>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import {compare, subNum, addNum, _toString} from '../utils.js'
  import {numberProps} from '../index'

  export default {
    name: 'syue-stepper',
    components: {},
    props: numberProps,
    data () {
      return {
        currentNum: '', // 当前number
        prevNum: 0, // 上一个正确数值
        inputNum: '', // input 获得焦点的值
        formatted: 1 // 格式化的值
      }
    },
    computed: {
      // _min () {
      //   return _toString(this.min)
      // },
      // _max () {
      //   return _toString(this.max)
      // },
      _step () {
        return _toString(this.step)
      },
      // isMin () {
      //   // 空字符串不允许点击
      //   if (this.inputNum === '') {
      //     return true
      //   }
      //   if (this._min === '') {
      //     return false
      //   }
      //   return compare(this.inputNum, this._min) !== 1
      // },
      // isMax () {
      //   if (this._max === '' || this.inputNum === '') {
      //     return false
      //   }
      //   return compare(this.inputNum, this._max) !== -1
      // },
      // 精度
      precision () {
        return this.decimalMaxDigits
      },
      // 是否允许小数
      isInteger () {
        return true
      },
      contentLength () {
        if (this.currentNum === '') {
          return 2
        }
        const length = this.currentNum.length;
        return length > 2 ? length : 2
      }
    },
    watch: {
      value: {
        handler (val) {
          if (String(val) !== this.currentNum) {
            this.changeCurrentNum(String(val))
          }
        },
        immediate: true
      },
      // _min (val) {
      //   if (this.currentNum < val) {
      //     this.changeCurrentNum(val)
      //     this.inputNum = this.currentNum
      //   }
      // },
      // _max (val) {
      //   if (compare(this.currentNum, val) === 1) {
      //     this.changeCurrentNum(val)
      //     this.inputNum = this.currentNum
      //   }
      // }
    },
    methods: {
      // 更改数据
      changeCurrentNum (val) {
        let _val = val
        let oldVal = this.inputNum
        if (_val === oldVal) {
          this.currentNum = _val
          return
        }
        // const _isMin = compare(val, this._min) === -1 && this._min !== ''
        // const _isMax = compare(val, this._max) === 1 && this._max !== ''
        // if (_isMin) {
        //   _val = this._min
        // } else if (_isMax) {
        //   _val = this._max
        // }
        if (!this.isInteger && val.indexOf('.') > -1) {
          _val = oldVal
        }
        this.currentNum = _val
        this.inputNum = _val
      },
      // 减法
      $_reduce () {
        if (this.disabled) {
          return
        }
        this.$_change(subNum(this.inputNum || '0', this._step))
      },
      // 加法
      $_add () {
        if (this.disabled) {
          return
        }
        this.$_change(addNum(this.inputNum || '0', this._step))
      },
      // 输入框输入
      $_input (event) {
        const reg = /(-?[0-9]?\d*\.?\d*)|(0\.\d*[0-9])/
        const value = event.target.value.match(reg)[0]
        this.changeCurrentNum(value)
        this.$emit('input', value)
      },
      //
      $_change (val) {
        this.changeCurrentNum(val)
        this.$emit('input', this.currentNum)
        this.$emit('validateField')
      },
      // 失去焦点
      $_blur () {
        this.$_change(this.inputNum)
        this.$emit('blur', true)
      },
      // 获取焦点
      $_focus () {
        this.$emit('focus', true)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .is-required {
    .syue-stepper-number {
      ::v-deep input {
        background-color: #FFFDEF !important;
      }
    }
  }

  .syue-stepper {
    -webkit-font-smoothing: antialiased;
    font-size: 30px;
    display: flex;
    line-height: 40px;
    border: 1px solid #d0d0d0;

    &.disabled {
      .syue-stepper-button::before, .syue-stepper-button::after {
        opacity: 0.3;
      }

      input {
        opacity: 0.3;
      }
    }

    .syue-stepper-button {
      width: 40px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #f5f7fa;
      color: #727272;
      cursor: pointer;
      font-size: 14px;

      &.disabled {
        color: #c0c4cc;
        cursor: not-allowed;
      }

      &-reduce {
        left: 1px;
        border-right: 1px solid #d0d0d0;
      }

      &-add {
        right: 1px;
        border-left: 1px solid #d0d0d0;
      }
    }

    .syue-stepper-number {
      position: relative;
      font-size: 14px;
      width: 100%;
      display: inline-block;
      line-height: 1;

      input {
        /* -webkit-appearance: none;
        padding: 0 40px; */
        text-align: center;
        background-color: #fff;
        background-image: none;
        border: 0px solid #d0d0d0;
        box-sizing: border-box;
        color: #303030;
        display: inline-block;
        font-size: inherit;
        height: 100% !important;
        line-height: 40px;
        outline: none;
        // padding: 0 15px;
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        width: 100%;
        cursor: pointer;
      }
    }
  }

  .syue-stepper-mini {
    line-height: 28px;

    .syue-stepper-button {
      width: 28px;
      height: 28px;
      line-height: 28px;
    }

    .syue-stepper-number {
      input {
        height: 28px;
        line-height: 28px;
      }
    }
  }

  .syue-stepper-small {
    line-height: 32px;

    .syue-stepper-button {
      width: 32px;
      height: 32px;
      line-height: 32px;
    }

    .syue-stepper-number {
      input {
        height: 32px;
        line-height: 32px;
      }
    }
  }

  .syue-stepper-medium {
    line-height: 36px;

    .syue-stepper-button {
      width: 36px;
      height: 36px;
      line-height: 36px;
    }

    .syue-stepper-number {
      input {
        height: 36px;
        line-height: 36px;
      }
    }
  }
</style>
